var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 8.99973H12.67L7.79 13.8797C7.4 14.2697 7.4 14.9097 7.79 15.2997C8.18 15.6897 8.81 15.6897 9.2 15.2997L15.79 8.70973C16.18 8.31973 16.18 7.68973 15.79 7.29973L9.21 0.699727C8.82 0.309727 8.19 0.309727 7.8 0.699727C7.41 1.08973 7.41 1.71973 7.8 2.10973L12.67 6.99973H1.5C0.95 6.99973 0.5 7.44973 0.5 7.99973C0.5 8.54973 0.95 8.99973 1.5 8.99973Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextIcon);
export default __webpack_public_path__ + "static/media/nextIcon.456df766a0e55ccd3431077f3415d0a5.svg";
export { ForwardRef as ReactComponent };